export default "__VITE_ASSET__Ctc8VLAd__"